var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 31,
    viewBox: "0 0 109 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Front Camera"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.152344,
    y: 0.0976562,
    width: 68.0585,
    height: 30.0014,
    rx: 14.7021,
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Lens 1",
    cx: 93.0656,
    cy: 15.0984,
    rx: 15.0021,
    ry: 15.0007,
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lens",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0929 23.7987C97.6966 23.7987 101.42 19.9975 101.42 15.3194C101.42 10.6414 97.6966 6.84014 93.0929 6.84014C88.4892 6.84014 84.7659 10.6414 84.7659 15.3194C84.7659 19.9975 88.4892 23.7987 93.0929 23.7987Z",
    fill: "url(#paint0_radial_601_13997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0929 23.7987C97.6966 23.7987 101.42 19.9975 101.42 15.3194C101.42 10.6414 97.6966 6.84014 93.0929 6.84014C88.4892 6.84014 84.7659 10.6414 84.7659 15.3194C84.7659 19.9975 88.4892 23.7987 93.0929 23.7987Z",
    fill: "url(#paint1_angular_601_13997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0929 23.7987C97.6966 23.7987 101.42 19.9975 101.42 15.3194C101.42 10.6414 97.6966 6.84014 93.0929 6.84014C88.4892 6.84014 84.7659 10.6414 84.7659 15.3194C84.7659 19.9975 88.4892 23.7987 93.0929 23.7987Z",
    fill: "url(#paint2_angular_601_13997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0929 23.7987C97.6966 23.7987 101.42 19.9975 101.42 15.3194C101.42 10.6414 97.6966 6.84014 93.0929 6.84014C88.4892 6.84014 84.7659 10.6414 84.7659 15.3194C84.7659 19.9975 88.4892 23.7987 93.0929 23.7987Z",
    stroke: "#080F21",
    strokeWidth: 0.554102
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line",
    opacity: 0.7,
    x1: 93.1155,
    y1: 7.11719,
    x2: 93.1155,
    y2: 23.5217,
    stroke: "black",
    strokeWidth: 1.38526
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_601_13997",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.0929 15.3194) rotate(90) scale(8.20224 8.04993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#081A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#1F3A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#375F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#274871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "#0D1528"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_601_13997",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.0929 15.3194) rotate(90) scale(8.20224 8.04993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_601_13997",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.0929 15.3194) rotate(90) scale(8.20224 8.04993)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885417,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontCamera);
export default __webpack_public_path__ + "static/media/Front_Camera.3ae780b1034d0513acade425460035e3.svg";
export { ForwardRef as ReactComponent };